/**
 * Development environment (default).
 *
 * The Firebase Web config below is a *public client identifier*, not a secret:
 * access is gated by Firebase Authentication and Firestore security rules, plus
 * API-key restrictions in the GCP console. It is safe to commit.
 *
 * The production build replaces this file with `environment.prod.ts` via
 * `fileReplacements` in angular.json.
 */
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCAHcumbIMmosBJ3HFwBC2cKe_KHa_2XRk',
    authDomain: 'vestorise-dev.firebaseapp.com',
    projectId: 'vestorise-dev',
    storageBucket: 'vestorise-dev.firebasestorage.app',
    messagingSenderId: '116146284961',
    appId: '1:116146284961:web:caa015e31492369fd243e0',
  },
  // API served via the Firebase Hosting proxy site → Cloud Run (vestorise-dev).
  apiBaseUrl: 'https://api.dev.vestorise.xyz',
} as const;
